import {Component, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {FormListRequesters} from '../../../../common/services/requesters-form/requesters-form.model';
import {MatDataSourceGeneric} from '@Services/base/daoService';
import {ActionDataTable, ColumnDataTable, DataTableComponent} from '@Common/widgets/general/data-table';
import {SubSink} from '@Common/core/utils/subsink';
import {FormListRequestersService} from '../../../../common/services/requesters-form/requesters-form.service';
import {ActivatedRoute, Router} from '@angular/router';
import {finalize} from 'rxjs/operators';
import {PubSubService} from '@Common/core/services';
import {FormulaireService} from '../../../../common/services/formulaire/formulaire.service';
import {FormModel} from '../../../../common/components/form/models';
import {MatDialog} from '@angular/material/dialog';
import {RequesterEditComponent} from './requester-edit/requester-edit.component';
import {RequesterService} from '../../../../common/services/requesters-form/requester.service';
import {Requester} from '../../../../common/services/requesters-form/requester.model';
import {DialogData, DialogValidationComponent} from '@Common/widgets/general/dialog-validation';
import {SnackBarToastyService, typeToast} from '@Common/widgets/general/snack-bar';

@Component({
  selector: 'app-requesters-list-form-edit',
  templateUrl: './requesters-list-form-edit.component.html',
  styleUrls: ['./requesters-list-form-edit.component.scss']
})
export class RequestersListFormEditComponent implements OnInit, OnDestroy {
  listRequestersModel: FormListRequesters;
  formModel: FormModel;
  dsRequesters: MatDataSourceGeneric<Requester> = new MatDataSourceGeneric<Requester>();
  extraParams: Map<string, string> = new Map<string, string>();
  countList = -1;
  @ViewChild(DataTableComponent, { static: false }) dataTable: DataTableComponent;
  columns: ColumnDataTable[] = [{
    columnDef: 'user__last_name', header: 'Nom', display: (row: Requester) => row.user_obj?.last_name || '',
    sort: true,
  }, {
    columnDef: 'first_name', header: 'Prénom', display: (row: Requester) => row.user_obj?.first_name || '',
    sort: false
  },
    {
      columnDef: 'user__email', header: 'Email', display: (row: Requester) => row.user_obj?.email || '',
      sort: true,
    }, {
    columnDef: 'informations', header: 'Informations', display: (row: Requester) => row.informations || '',
    sort: false
  }];
  actions: ActionDataTable[] = [{
    label: 'delete', tooltip: 'Supprimer ce membre', icon: 'delete',
    click: (row: Requester) => this._deleteMember(row),
    iconcolor: 'warn',
    }, {
    label: 'edition', tooltip: 'Modifier les informations de ce membre', icon: 'edit',
    click: (row: Requester) => this.openAddOrUpdateMember('edit', row)
  }];
  uuidForm = '';
  subSink = new SubSink();
  constructor(private router: Router, private route: ActivatedRoute,
              public dialog: MatDialog,
              private pubSubSvc: PubSubService,
              private snakeSvc: SnackBarToastyService,
              private formulaireSvc: FormulaireService,
              private formListRequestersSvc: FormListRequestersService,
              private requesterSvc: RequesterService) {
    this.dsRequesters.daoService = requesterSvc;
  }

  ngOnInit(): void {
    const idList = this.route.snapshot.paramMap.get('id');
    this.uuidForm = this.route.snapshot.paramMap.get('uuid');
    console.log(`${idList} ${this.uuidForm}`);
    if (idList) {
      this.extraParams.set('list_requester', idList);
      this._fetchList(idList);
      this._fetchForm(this.uuidForm);
    }
  }
  public openAddOrUpdateMember(action: 'add' | 'edit', member: Requester = null) {
    const data = {listRequester: this.listRequestersModel, action: action, member: member};
    const dialogRef = this.dialog.open(RequesterEditComponent, {data: data, width: '800px'});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(() => this.dataTable?.reload());
  }
  public goListToListsRequesters() {
    this.router.navigate(['requesters-list', this.uuidForm], {relativeTo: this.route.parent});
  }

  /**
   * Informations sur la liste des sollicités à gérer
   * @param id
   * @private
   */
  private _fetchList(id) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.formListRequestersSvc
      .get(id)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(_list => this.listRequestersModel = _list);
  }

  /**
   * Informations sur le formulaire
   * @param uuid
   * @private
   */
  private _fetchForm(uuid) {
    this.pubSubSvc.publish('loading', true);
    this.subSink.sink = this.formulaireSvc
      .get(uuid)
      .pipe(finalize(() => this.pubSubSvc.publish('loading', false)))
      .subscribe(_form => this.formModel = _form);
  }

  private _deleteMember(row: Requester) {
    const _member = `${row.user_obj?.first_name} ${row.user_obj?.last_name}`;
    const data = new DialogData();
    data.title = `Enlever un membre de la liste`;
    data.message = `<p>Souhaitez-vous enlever ${_member} de la liste ?</p>`;

    const dialogRef = this.dialog.open(DialogValidationComponent, {data: data});
    dialogRef.updatePosition({top: '50px'});
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.subSink.sink = this.requesterSvc
          .delete(row)
          .subscribe(_ => {
            this.snakeSvc.toasty('Suppression de membre', `${_member} a bien été enlevé de la liste`, typeToast.success);
            this.dataTable?.reload();
          });
      }
    });
  }

  ngOnDestroy(): void {
  }
}
